import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-notification-confirm-popup',
  standalone: false,
  templateUrl: './notification-confirm-popup.html',
  styleUrl: './notification-confirm-popup.scss'
})
export class NotificationConfirmPopup {
  constructor(private readonly dialogRef: MatDialogRef<NotificationConfirmPopup>) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}